import initYandexMap from './map/initialize';
import getYandexMap from '../maps/map';
import errorHandler from './map/error-handler';
import { fromTrainsBtn, toTrainsBtn, fromTrainsShow, toTrainsShow } from "./toggler/trains-toggle";

fromTrainsBtn?.addEventListener('click', fromTrainsShow);
toTrainsBtn?.addEventListener('click', toTrainsShow);

window.addEventListener('scroll', () => getYandexMap(initYandexMap, errorHandler), {once: true});
